import CharacterHeaderDesktop from "./CharacterHeaderDesktop";

export default CharacterHeaderDesktop;
export { CharacterHeaderDesktop };
